import {
	useCreateTagType,
	useDeleteTagType,
	useOrganisation,
	useUpdateTagType,
} from "@/networking/organisation.hooks";
import { SettingsLeaf } from "./SettingsLeafLayout";
import TaxonomyCrudEditor from "./TaxonomyCrudEditor";

/**
 * "Kundtaggar" — CRUD over the org's `customerTagTypes` taxonomy via the
 * dedicated tag-type endpoints. Purely descriptive labels (no validity).
 */
const KundtaggarPage = () => {
	const { data: organisation } = useOrganisation();
	const { mutateAsync: createTagType, isLoading: isCreating } = useCreateTagType();
	const { mutateAsync: updateTagType, isLoading: isUpdating } = useUpdateTagType();
	const { mutateAsync: deleteTagType, isLoading: isDeleting } = useDeleteTagType();

	return (
		<SettingsLeaf
			title="Kundtaggar"
			description="Beskrivande taggar som kan sättas på kunder och användas som filter i kundlistan."
		>
			<TaxonomyCrudEditor
				items={organisation?.customerTagTypes ?? []}
				addLabel="Lägg till tagg"
				emptyText="Inga kundtaggar har skapats ännu."
				showColor
				showListViewVisibility
				isSaving={isCreating || isUpdating || isDeleting}
				onCreate={({ name, color, showInListViews }) =>
					createTagType({ taxonomy: "customer", name, color, showInListViews })
				}
				onUpdate={(key, { name, color, showInListViews }) =>
					updateTagType({ taxonomy: "customer", key, name, color, showInListViews })
				}
				onDelete={(key) => deleteTagType({ taxonomy: "customer", key })}
				deleteTitle={(item) => `Ta bort taggen "${item.name.sv}"?`}
				deleteDescription={() => "Taggen tas bort från alla kunder. Detta går inte att ångra."}
			/>
		</SettingsLeaf>
	);
};

export default KundtaggarPage;
